var map = {
	"./about.jpg": 16,
	"./carousel-1.jpg": 970,
	"./carousel-2.jpg": 647,
	"./icon/icon-1.png": 489,
	"./icon/icon-10.png": 973,
	"./icon/icon-2.png": 220,
	"./icon/icon-3.png": 898,
	"./icon/icon-4.png": 161,
	"./icon/icon-5.png": 29,
	"./icon/icon-6.png": 431,
	"./icon/icon-7.png": 932,
	"./icon/icon-8.png": 346,
	"./icon/icon-9.png": 885,
	"./project-1.jpg": 461,
	"./project-2.jpg": 465,
	"./project-3.jpg": 994,
	"./project-4.jpg": 379,
	"./team-1.jpg": 101,
	"./team-2.jpg": 209,
	"./team-3.jpg": 781,
	"./team-4.jpg": 702,
	"./testimonial-1.jpg": 600,
	"./testimonial-2.jpg": 715,
	"./testimonial-3.jpg": 866,
	"./testimonial-4.jpg": 648
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 459;